__turbopack_context__.v({
  "icon": "TopUpNavLink-module__miMQYa__icon",
  "root": "TopUpNavLink-module__miMQYa__root",
  "selected": "TopUpNavLink-module__miMQYa__selected",
});
